import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Page, StatusBadge } from "@/components/Shell";
import { api, errMsg } from "@/lib/api";

const LEGEND = [["working", "Verified working"], ["sandbox_tested", "Tested in sandbox"], ["configured_untested", "Configured, not yet verified"], ["awaiting_credentials", "Awaiting credentials"], ["not_implemented", "Not implemented"]];

export default function Integrations() {
  const [items, setItems] = useState(null);
  const [phone, setPhone] = useState("");
  const load = () => api.get("/integrations").then((r) => setItems(r.data.items)).catch((e) => toast.error(errMsg(e)));
  useEffect(() => { load(); }, []);
  const wa = items?.find((i) => i.key === "whatsapp");

  const link = async (e) => {
    e.preventDefault();
    try { await api.post("/integrations/whatsapp/link", { phone }); setPhone(""); load(); toast("Number linked."); } catch (err) { toast.error(errMsg(err)); }
  };
  const unlink = async () => { try { await api.delete("/integrations/whatsapp/link"); load(); } catch (e) { toast.error(errMsg(e)); } };

  return (
    <Page eyebrow="Honest status" title="Integrations" intro="What Feerd can actually do today. Nothing is marked working until it has been verified against the real provider.">
      <div className="flex flex-wrap gap-x-6 gap-y-3 mb-12">{LEGEND.map(([s, l]) => <span key={s} className="flex items-center gap-2 text-xs text-[#5f5f5f]"><StatusBadge status={s} /> {l}</span>)}</div>
      <div className="border-t border-[#1c1c1c]" data-testid="integration-matrix">
        {(items || []).map((i) => (
          <div key={i.key} className="grid md:grid-cols-12 gap-3 md:gap-8 py-7 border-b border-[#1c1c1c] items-baseline" data-testid={`integration-row-${i.key}`}>
            <p className="md:col-span-4 font-display text-xl md:text-2xl text-ivory">{i.name}</p>
            <div className="md:col-span-3"><StatusBadge status={i.status} testId={`integration-status-${i.key}`} /></div>
            <p className="md:col-span-5 text-sm text-[#8A8A8A] leading-relaxed">{i.detail}</p>
          </div>
        ))}
      </div>
      <section className="mt-20 max-w-3xl">
        <p className="eyebrow mb-4">WhatsApp channel mapping</p>
        <p className="text-sm text-[#8A8A8A] leading-relaxed mb-8">Link your own WhatsApp number so inbound messages are routed to your account. Messages from unlinked numbers are ignored. Linking is stored but stays inactive until Meta credentials are configured.</p>
        {wa?.linked_number ? (
          <div className="flex items-center gap-6"><p className="font-display text-2xl text-ivory" data-testid="whatsapp-linked-number">+{wa.linked_number}</p>
            <button onClick={unlink} data-testid="whatsapp-unlink-button" className="text-xs tracking-[0.2em] uppercase text-[#8A8A8A] hover:text-[#e2a6a6]">Unlink</button></div>
        ) : (
          <form onSubmit={link} className="flex flex-col sm:flex-row gap-4" data-testid="whatsapp-link-form">
            <input value={phone} onChange={(e) => setPhone(e.target.value)} placeholder="919876543210" data-testid="whatsapp-phone-input"
              className="flex-1 bg-transparent border-b border-[#2A2A2A] focus:border-[#D8BFD8] outline-none py-3 text-ivory placeholder:text-[#4a4a4a]" />
            <button data-testid="whatsapp-link-button" className="px-6 py-3 rounded-full border border-[#2A2A2A] text-[#C0C0C0] text-xs tracking-[0.2em] uppercase hover:text-ivory hover:border-[#C0C0C0]/60 transition-colors">Link number</button>
          </form>
        )}
      </section>
    </Page>
  );
}
